<img src="/assets/img/lesson-icon.svg" alt="Lesson Icon">

<h2>Resources for Teachers</h2>

<p>Sample <a href="/lessons">Lesson Plans</a> written by educators for grades from 9 to 12 based on the Next Generation Science Standards for a wide range of topics. While STARS is designed to be easy to use, we have included <a href="/guides">Teacher's Guides</a> on how to use each of the STARS APPS.</p>
